import { render, staticRenderFns } from "./GraficosSection.vue?vue&type=template&id=23ac1b43&scoped=true&"
import script from "./GraficosSection.vue?vue&type=script&lang=js&"
export * from "./GraficosSection.vue?vue&type=script&lang=js&"
import style0 from "./GraficosSection.vue?vue&type=style&index=0&id=23ac1b43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac1b43",
  null
  
)

export default component.exports